// src/middleware/AuthMiddleware.js
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import {
  selectIsAuthenticated,
  selectAccessToken,
  setLoginModal,
} from "../store/auth-slice";
import { refreshTokenIfNeeded, setupAutoRefresh } from "../utils/token";

// Component to protect routes that require authentication
export const RequireAuth = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const accessToken = useSelector(selectAccessToken);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // If authenticated, ensure token is valid and set up auto-refresh
    if (isAuthenticated && accessToken) {
      refreshTokenIfNeeded().then((valid) => {
        if (valid) {
          setupAutoRefresh();
        }
      });
    }
  }, [isAuthenticated, accessToken]);

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    // Store the current path to redirect back after login
    sessionStorage.setItem("redirectUrl", location.pathname);

    // Show login modal instead of redirecting
    dispatch(setLoginModal(true));

    // Redirect to home page
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

// Component for public routes that still maintains authentication
export const PublicRoute = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const accessToken = useSelector(selectAccessToken);

  useEffect(() => {
    // If already authenticated, keep the token fresh
    if (isAuthenticated && accessToken) {
      refreshTokenIfNeeded().then((valid) => {
        if (valid) {
          setupAutoRefresh();
        }
      });
    }
  }, [isAuthenticated, accessToken]);

  return children;
};
